import React from 'react';

import SearchDropdownContainer from 'onboarding/common/SearchDropdown';

export class InputWithDropdown extends React.Component {
  static defaultProps = {
    autoFocus: false,
    onChangeHandler: () => {},
    onBlurHandler: () => {},
    validateChange: () => true,
    validateBlur: () => '',
  };

  constructor(props) {
    super(props);

    this.state = {
      inputValue: this.props.data.inputValue,
      errorMessage: '',
      touched: false,
    };
  }

  componentDidMount() {
    if (this.props.autoFocus && this.inputField) {
      this.inputField.focus();
    }
  }

  onChange = (event) => {
    const { target } = event;
    const { value } = target;
    const { id } = target;
    if (this.props.validateChange && !this.props.validateChange(value)) {
      return;
    }
    this.setState({ inputValue: value }, () => {
      if (this.props.onChangeHandler) {
        this.props.onChangeHandler(value, id);
      }
    });
    if (this.props.validateBlur && this.state.touched) {
      const errorMessage = this.props.validateBlur(value);
      this.setState({ errorMessage });
    }
  };

  onBlur = (event) => {
    const { validateBlur, onBlurHandler } = this.props;
    const { id, value } = event.target;

    if (validateBlur) {
      this.setState({ errorMessage: validateBlur(value) });
    }

    if (onBlurHandler) {
      onBlurHandler(value, id);
    }

    if (!this.state.touched) {
      this.setState({ touched: true });
    }
  };

  render() {
    const errorMessageDivClassName = this.state.errorMessage ? 'input-prompt-show' : 'input-prompt-hide';
    const inputClassName = this.state.errorMessage ? 'utl-full-width has-error col-md-7' : 'utl-full-width col-md-7';
    return (
      <div className="form-horizontal col-lg-8">
        <label htmlFor={this.props.data.id} className="row">
          <span className="field-name col-md-5"> {this.props.data.label}</span>
          <input
            ref={(input) => {
              if (input) {
                this.inputField = input;
              }
            }}
            className={inputClassName}
            id={this.props.data.id}
            type={this.props.data.type}
            placeholder={this.props.data.placeholder}
            value={this.state.inputValue}
            onChange={this.onChange}
            onBlur={this.onBlur}
          />
        </label>
        <div className="input-baseline">
          {this.state.inputValue.replace(/\s/g, '').length > 0 && (
            <SearchDropdownContainer
              templates={this.props.templates}
              addNewService={this.props.onNewClick}
              selectTemplate={this.props.onSelect}
            />
          )}
        </div>
        <div className={errorMessageDivClassName}>
          <div className="input-baseline" />
          <span>{this.state.errorMessage}</span>
        </div>
      </div>
    );
  }
}

export default InputWithDropdown;
